/**
 * A People Leader's Leader Observations about a team member for the period: every
 * observation, each tagged with its KPA or General, with the area filter, and adding
 * one defaults to General with the KPA optional. The member card's tab and the
 * check-in's tab both show it (HR UAT list #2), so the two can't drift.
 */
import type { ComponentProps } from 'react'
import { NotebookPen } from 'lucide-react'
import EvidencePortfolio from '../EvidencePortfolio'

type PortfolioProps = ComponentProps<typeof EvidencePortfolio>
type LeaderObservationsPanelProps = Pick<
  PortfolioProps,
  | 'evidence' | 'kpaOptions' | 'currentUserId' | 'targetUserId' | 'reviewPeriod' | 'readOnly' | 'viewMode'
  | 'checkEvidenceEditable' | 'onAddEvidence' | 'onUpdateEvidence' | 'onDeleteEvidence' | 'onUploadDocument'
  | 'onRefreshEvidence' | 'onClassifyEvidence'
> & { memberName?: string }

export function LeaderObservationsPanel({ memberName, reviewPeriod, ...portfolio }: LeaderObservationsPanelProps) {
  return (
    <>
      <div className="mb-4">
        <h3 className="flex items-center gap-2 text-lg font-semibold text-gray-900">
          <NotebookPen className="h-5 w-5 text-heritage-blue" />
          Leader Observations
        </h3>
        <p className="text-sm text-gray-500 mt-0.5">
          Your notes about {memberName?.split(' ')[0] || 'this team member'} for{' '}
          {reviewPeriod === 'MIDYEAR' ? 'Mid-Year' : 'Year-End'} — about one KPA, or general.
        </p>
      </div>
      <EvidencePortfolio
        {...portfolio}
        kpaId={undefined}
        userRole="manager"
        reviewPeriod={reviewPeriod}
        observationsMode={true}
        hideUploadButton={true}
        ownerDisplayName={memberName}
      />
    </>
  )
}
